import { jsxs, jsx } from 'react/jsx-runtime';
import { useMemo } from 'react';
import '../../../assets/icons/cart.svg.mjs';
import '../../../assets/icons/cartEmpty.svg.mjs';
import '../../StyleableSvgImage/index.mjs';
import { Wrap, CartQuantityEllipse } from './CartIcon.styles.mjs';
import { StyleableSvgImage } from '../../StyleableSvgImage/StyleableSvgImage.mjs';
import CartFullIcon__default from "../../../assets/cart.svg";
import CartEmptyIcon__default from "../../../assets/cartEmpty.svg";
"use strict";
const CartIcon = ({
  className,
  itemCount,
  width = 20,
  height = 20,
  motif = "light",
  onMouseEnter,
  onMouseLeave
}) => {
  const cartQuantityText = useMemo(() => {
    if (itemCount && itemCount > 0) {
      return itemCount > 99 ? "99+" : itemCount.toString();
    }
    return null;
  }, [itemCount]);
  return /* @__PURE__ */jsxs(Wrap, {
    className,
    onMouseEnter,
    onMouseLeave,
    children: [/* @__PURE__ */jsx(StyleableSvgImage, {
      src: itemCount > 0 ? CartFullIcon__default : CartEmptyIcon__default,
      width,
      height
    }), /* @__PURE__ */jsx(CartQuantityEllipse, {
      $motif: motif,
      $show: !!cartQuantityText,
      "data-test-id": "cart-quantity",
      children: cartQuantityText
    })]
  });
};
export { CartIcon };
//# sourceMappingURL=CartIcon.mjs.map
